angular.module("ainapp")
    .controller("CustomersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Customers";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.Init = function () {

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                })


                $scope.filter = {
                    Keyword: ""
                }

                $scope.load = 0;
                $scope.ViewVal = 0;
            }
            $scope.Init();


            $scope.search = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: ""
                }
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.AccountsInCustomerView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            Salutation: {
                                type: "string",
                                editable: false,
                            },
                            AccountCode: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            MobileNo: {
                                type: "string",
                                editable: false,
                            },
                            Email: {
                                type: "string",
                                editable: false,
                            },
                            TRNNo: {
                                type: "string",
                                editable: false,
                            },
                            Address: {
                                type: "string",
                                editable: false,
                            },
                            "City.Name": {
                                type: "string",
                                editable: false,
                            },
                            "AccountType.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                excelExport: function (e) {
                    var rows = e.workbook.sheets[0].rows;
                    e.workbook.sheets[0].frozenRows = 2;

                    var headerRow = {
                        height: 70,
                        cells: [{
                            value: "Customer List",
                            fontSize: 30,
                            colSpan: 5
                        }]
                    };

                    var footerRow = {
                        height: 70,
                        cells: [{
                            value: "Total revenue 1 000 000",
                            fontSize: 30,
                            colSpan: 5
                        }]
                    };

                    rows.unshift(headerRow);
                    rows.push(footerRow);

                    // // First I loop through all rows in the worksheet
                    // e.workbook.sheets[0].rows.forEach(function (row) {

                    //     // Ignore 'data' rows (only use 'header' and 'footer')
                    //     if (row.type != 'data') {

                    //         // Loop through all cells of the row
                    //         row.cells.forEach(function (cell) {

                    //             // Here I overwrite the cell value with its translation
                    //             // You have to implement translate() so it works with angular
                    //             cell.value = "hello";
                    //         });
                    //     }
                    // });
                },
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "AccountCode",
                        title: "Account Code",
                        headerTemplate: "{{LanguageData.code}}",
                    },
                    {
                        field: "Salutation",
                        title: "Salutation",
                    },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                    },
                    {
                        field: "NameAr",
                        title: "Name Arabic",
                        headerTemplate: "{{LanguageData.NameinArabic}}",
                    },
                    {
                        field: "MobileNo",
                        title: "Mobile No",
                        headerTemplate: "{{LanguageData.MobileNo}}",
                    },
                    {
                        field: "Email",
                        title: "Email",
                        headerTemplate: "{{LanguageData.Email}}",
                    },
                    {
                        field: "TRNNo",
                        title: "TRN No",
                        headerTemplate: "{{LanguageData.TRNNo}}",
                    }, {
                        field: "Address",
                        title: "Address",
                        headerTemplate: "{{LanguageData.Address}}",
                        width: '220px'
                    },
                    {
                        field: "City.Name",
                        title: "City",
                        headerTemplate: "{{LanguageData.City}}",

                    },
                    {
                        field: "AccountType.Name",
                        title: "Account Type",
                        headerTemplate: "{{LanguageData.AccountType}}",

                    },
                    {
                        field: "EmployeeId",
                        title: "Assigned",
                        template: "<select class='form-select'  ng-Options='c.Id as c.Name for c in Employees' ng-model='dataItem.EmployeeId' ng-change='UpdateEmployeeToAccount(dataItem)'></select>"
                    },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button>   <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button><button class=' btn-default btn-sm fa fa-th'  ng-click='goCostcenters(dataItem)'></button>  ",
                        width: '100px'
                    },
                ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }


            $scope.goCostcenters = function (data) {
                $state.go("AccountCostCenters", {
                    AccountMasterId: data.Id
                })
            };

            $scope.Edit = function (data) {
                $state.go("editCustomer", {
                    AccountId: data.Id
                })
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAccountMaster($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.UpdateEmployeeToAccount = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateEmployeeToAccount(data.Id, data.EmployeeId).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }



            $scope.SaveData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentTransAccount.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentTransAccount.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.CurrentTransAccount.Name == "") {
                    toastr.warning("Enter Name");
                } else if ($scope.CurrentTransAccount.MobileNo == "") {
                    toastr.warning("Enter Mobile No");
                } else if ($scope.CompanyProfile.IsCusTRNMandatory && $scope.CurrentTransAccount.TRNNo == "") {
                    toastr.warning("Enter TRN No");
                } else if ($scope.CompanyProfile.IsCusLicenseMandatory && $scope.CurrentTransAccount.LicenseNo == "") {
                    toastr.warning("Enter License No");
                } else {

                    $scope.CurrentTransAccount.AccountBranchs = [];
                    angular.forEach($scope.CurrentTransAccount.BranchIds, function (e) {
                        var tt = {
                            BranchId: e,
                        }
                        $scope.CurrentTransAccount.AccountBranchs.push(tt);
                    })


                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveAccountCustomer($scope.CurrentTransAccount).then(function (response) {
                        if (response.data == "Success") {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");

                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

        }])
